// extracted by mini-css-extract-plugin
export var button = "_lf-2";
export var card = "_lf-0";
export var closeButtonContainer = "_lf-3";
export var iconContainer = "_lf-1";